export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.02 5.465c-.424 0-.844.086-1.233.255L4 10.027V5.493a.92.92 0 01.573-.853L15.653.147a.894.894 0 01.694 0l11.08 4.493a.92.92 0 01.573.853v5.173L17.253 5.72a3.106 3.106 0 00-1.233-.255zM15.773 8.2a.507.507 0 01.374 0L28 13.587v8.133a4.573 4.573 0 01-2.2 3.853l-9.453 6.2a.654.654 0 01-.694 0l-9.453-6.2A4.574 4.574 0 014 21.72v-8.813L15.773 8.2zm0 16.533l5.334-8v-.026a1.334 1.334 0 00-2.214-1.467l-4.44 6.667-1.506-1.52a1.339 1.339 0 00-1.894 1.893l2.667 2.667a1.333 1.333 0 00.947.386h.133a1.333 1.333 0 00.973-.6z\" fill=\"#A4A9B6\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};